<template>
  <div class="omsPc">
    <p class="title" >
      <img src="./img/PcTitle.png" alt="">
    </p>
        <!-- <p class="title" :class="{test:true,testenter:testShow}" ref="testref">
      <img src="./img/PcTitle.png" alt="">
    </p> -->
    <div class="omsPCBox">
      <p class="titleImg"><img src="./img/PcContent1.png" alt=""></p>
      <p class="titleText">实现<span>订单归集、调度、费用核算</span>的统一管理 </p>
      <p class="contentText">三方物流管理系统是通过订单收集、智能调度、费用管控、统计报表等功能，对三方物流管理过程中的收单、调度、回单、费用核算管理等功能综合运用的管理系统，有效控制并跟踪订单作业和费用管理全过程，实现或完善企业的三方物流信息管理。</p>
      <p class="contentText">该系统不仅要执行三方物流过程中的所有实际操作，而且也需要与其他系统的数据对接，结合使用。</p>
      <p class="titleText"><span>OMS</span> 与 <span>WMS</span> 的 <span>分工</span></p>
      <p class="PcContent2"><img class="image" src="./img/PcContent2.png" alt=""></p>
      <p class="titleText">实现三方业务 <span>全链条的管理全覆盖，</span> 建立 <span>透明化一体化的OMS系统</span></p>
      <p class="PcContent3"><img class="image" src="./img/PcContent3.png" alt=""></p>
      <p class="titleText">时空OMS价值： <span>优化三方物流运营管理和执行</span></p>
      <p class="PcContent4"><img class="image" src="./img/PcContent4.png" alt=""></p>
      <p class="titleText"><span>时空OMS核心功能</span>  适应流通行业各种业务模式，实现三方物流全流程管理</p>
      <p class="PcContent5"><img class="image" src="./img/PcContent5.png" alt=""></p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentScroll: 0, // 当前滚动位置
      testShow: false

    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.currentScroll = window.pageYOffset // 表示当前滚动的位置

      if (this.currentScroll >= this.$refs.testref.offsetTop - 100) { // 当前滚动位置到达testref的时候，显示div（100作为调整用）
        this.testShow = true
      }
    // if (this.currentScroll >= this.$refs.test2ref.offsetTop - 100) {
    //   this.testShow2 = true
    // }
    // if (this.currentScroll >= this.$refs.test3ref.offsetTop - 100) {
    //   this.testShow3 = true
    //   setTimeout(() => {
    //     this.testShow3 = false
    //   }, 400)
    }
    // }
  }
  // handleScroll () {
  //   this.currentScroll = window.pageYOffset // 表示当前滚动的位置

  //   if (this.currentScroll >= this.$refs.testref.offsetTop - 100) { // 当前滚动位置到达testref的时候，显示div（100作为调整用）
  //     this.testShow = true
  //   }
  // }
}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.omsPc{
  width: 100%;
  // 标题
  .title{
    width: 100%;
    height: 460px*$sun;
    img{
      width: 100%;
      height: 100%;
    }
  }
  // 内容
  .omsPCBox{
    width: 1200px*$sun;
    margin: 0 auto;
    // 标题文字
    .titleText{
      width: 100%;
      height: 34px*$sun;
      font-size: 28px*$sun;
      margin-bottom: 40px*$sun;
      span{
        color: red;
      }
    }
    // 文本文字
    .contentText{
      width: 100%;
      font-size: 24px*$sun;
      color: #666666;
      line-height: 50px*$sun;
      margin-bottom: 40px*$sun;
    }
    // 标题图片
    .titleImg{
      width: 417px*$sun;
      height: 107px*$sun;
      margin: 50px*$sun auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .PcContent2{
      width: 1100px*$sun;
      height: 437px*$sun;
      margin: 0 auto;
      margin-bottom: 50px*$sun;
    }
    .PcContent3{
      width: 885px*$sun;
      height: 428px*$sun;
      margin: 0 auto;
      margin-bottom: 50px*$sun;
    }
    .PcContent4{
      width: 100%;
      height: 566px*$sun;
      margin: 0 auto;
      margin-bottom: 50px*$sun;
    }
    .PcContent5{
      width: 1180px*$sun;
      height: 453px*$sun;
      margin: 0 auto;
      margin-bottom: 50px*$sun;
    }
  }
}
.image{
  width: 100%;
  height: 100%;
}
// 动画++++++++++++++++++++++++++++++++++
      .testenter{
        transform: translateY(0%)!important;  //滚动后的位置
        opacity: 1!important;  //滚动后显现
        transition: all .5s ease;
      }
      .test{
        transform: translateY(10%);  //滚动前的位置
        opacity: 0;   //滚动前设置透明隐藏
      }
</style>
